













































































































import settings from '@/settings'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import Menus from '@/components/menus'
import animated_number from '@/components/animated_number'

export default {
    name: 'dashboard'

    components: { Menus, animated_number }

    watch:
        "$store.state.selected_company.uid": (value)->
            # console.log "DASHBOARD WATCH SELECTED COMPANY", value
            if value == ""
                @alerts = {
                    absences_count: 0
                    formations_count: 0
                    interviews_count: 0
                }
                @events = []

        "$store.state.distribution_set": (value)->
            @company_set = value

    data: ()->
        company_billing_stats: []
        alerts:
            absences_count: 0
            formations_count: 0
            interviews_count: 0
        events: []
        routes:
            absences: 'company_absences'
            formations: 'company_formations'
            interviews: 'company_interviews'
        active_name: 'first'
        titles: ['Liste des métiers', 'Métiers à dupliquer']
        source_job_set: []
        target_job_set: []
        selected_jobs: []
        company_set: []
        source_uid: ""
        target_uid: ""
        props: {
          key: 'uid',
          label: 'name'
        }
        footer_key: 0

    computed:
        has_event_right: ()->
            return @has_access_right('events_show')

        user_is_admin: ()->
            return @$store.state.user_datas.profiles.indexOf('superadmin') != -1

    methods:
        has_access_right: t.has_access_right
        manage_people: t.manage_people
        python_date_formatter: t.python_date_formatter

        select_style: (count)->
            return "margin-left:"+(count*15).toString()+"px;"

        source_change: ()->
            # console.log "SOURCE IS CHANGE", @source_uid
            @get_jobs(@source_uid, 'source')
            return

        target_change: ()->
            # console.log "TARGET IS CHANGE", @target_uid
            @get_jobs(@target_uid, 'target')
            return

        tab_click: (tab, event)->
            # console.log "TAB IS CHANGE", tab, event
            return

        filter_method: (query, item)->
            return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1

        go_to_planning: ()->
            @$router.push(name:'planning')
            .catch((err)-> {})
            return

        click_on_tile: (tile_name)->
            # console.log "CLICK ON TILE ", tile_name, @routes[tile_name]
            if @$store.getters.current_company? and @$store.getters.current_company.uid != ''
                @$router.push(name:@routes[tile_name], params:{direct:true})
                .catch((err)-> {})
            return

        indicator_class: (tile_name)->
            indicator_class_name = 'indicator-positive'
            if @alerts? and @alerts[tile_name] > 0
                indicator_class_name = 'indicator-negative'
            return indicator_class_name

        get_calendar_events: ()->
            self = @
            today = new Date(Date.now())
            tomorrow = new Date(Date.now())
            tomorrow = new Date(tomorrow.setDate(tomorrow.getDate() + 1))
            # console.log "GET DASHBOARD EVENTS ", today, tomorrow
            q.run('get_calendar_event_set', [@$store.getters.current_company.uid, [], ['all'], [(@$store.state.user_datas.app_user.uid).toString()], false, @python_date_formatter(today).split(' ')[0], @python_date_formatter(tomorrow).split(' ')[0]])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("dashboard: get_calendar_events: then", e.message)
                else
                    # console.log "GET EVENTS : ", resp.body.data.calendar_event_set
                    self.events = resp.body.data.calendar_event_set
            .catch (resp)->
                n.catch_error(resp, "dashboard: get_calendar_events()")

        get_alerts: ()->
            self = @
            q.run('get_dashboard_alert_set', [@$store.getters.current_company.uid, @$store.state.user_datas.app_user.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("dashboard: get_alerts: then", e.message)
                else
                    # console.log "GET DASHBOARD ALERT : ", resp.body.data.dashboard_alert_set
                    self.alerts = resp.body.data.dashboard_alert_set
            .catch (resp)->
                n.catch_error(resp, "dashboard: get_alerts()")

        get_jobs: (uid, list_name)->
            self = @
            q.run('get_job_set', [uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("dashboard: get_jobs: then", e.message)
                else
                    # console.log "RUN QUERY JOBS : ", resp.body.data.job_set
                    if list_name == 'source'
                        self.source_job_set = resp.body.data.job_set
                    else
                        self.target_job_set = resp.body.data.job_set
                        # console.log "TARGET JOBS", self.target_job_set
            .catch (resp)->
                n.catch_error(resp, "dashboard: get_jobs()")

        get_company_billing_stats: ()->
            self = @
            q.run('get_company_billing_stats', [])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("dashboard: get_company_billing_stats: then", e.message)
                else
                    # console.log "GET DASHBOARD COMPANY BILLING STAT : ", resp.body.data.company_billing_stats
                    self.company_billing_stats = resp.body.data.company_billing_stats
            .catch (resp)->
                n.catch_error(resp, "dashboard: get_company_billing_stats()")

        duplicate_jobs: ()->
            # console.log "DUPLICATE JOBS", @source_uid, @target_uid
            if @source_uid == @target_uid or @target_uid == ""
                n.warning("Une société cible différente de la société source est nécessaire.")
                return
            if @selected_jobs.length == 0
                n.warning("Au moins un métier doit figurer dans la colonne 'Métiers à dupliquer'.")
                return

            self = @
            m.run('duplicate_job', [@selected_jobs, false, @target_uid])
            .then (resp)->
                # console.log "DUPLICATE JOB", resp.body.data.job_duplication
                if resp.body.data.job_duplication.ok
                    n.success()
                    self.selected_jobs = []
                    self.get_jobs(self.target_uid, 'target')
                    self.get_jobs(self.source_uid, 'source')
                else
                    n.gql_error("dashboard: duplicate_job: then", resp.body.data.job_duplication.message)
            .catch (resp)->
                n.catch_error(resp, "dashboard: duplicate_job()")
            return

    beforeMount: ()->
        if @$store.getters.current_company? and @$store.getters.current_company.uid != ''
            if @manage_people()
                @get_alerts()
            if @has_event_right
                @get_calendar_events()
        if @user_is_admin
            @get_company_billing_stats()
            @company_set = @$store.state.distribution_set
}
